/**
 * What the Pending Transactions screen does with GET /payouts/redemption-notes:
 * the answer is {download?: {fileName, url}, funds: [{fundId, count} | {fundId, error}]},
 * and the screen needs only the kind - something to download, nothing pending,
 * or nothing generated - and the funds whose note was not generated, with the reason.
 *
 * @param {{ download?: { fileName: string, url: string }, funds?: Array<{ fundId: string, count?: number, error?: string | null }> }} response
 * @returns {{ kind: 'download' | 'empty' | 'failed', url?: string, fileName?: string, failed: Array<{ fundId: string, error: string }> }}
 */
export function outcomeOf(response) {
    const failed = (response?.funds ?? [])
        .filter((f) => f.error !== undefined)
        .map((f) => ({ fundId: f.fundId, error: f.error || 'Not generated' }));
    if (response?.download) return { kind: 'download', url: response.download.url, fileName: response.download.fileName, failed };
    return { kind: failed.length ? 'failed' : 'empty', failed };
}

/** The sentence shown for funds whose note was not generated. */
export function failureText(failed) {
    return 'Not generated: ' + failed.map((f) => f.fundId + ' (' + f.error + ')').join(', ');
}
